import DateTime             from "dashboard/dist/Utils/DateTime";
import Utils                from "dashboard/dist/Utils/Utils";
import Common               from "Utils/Common";

// Types
import {
    EMAIL_QUEUE_LOADING,
    EMAIL_QUEUE_LIST, EMAIL_QUEUE_ELEM,
} from "Utils/Types";



// The initial State
const initialState = {
    loading   : false,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    filter    : {
        search   : "",
        fromDate : "",
        toDate   : "",
    },
    sort      : {
        orderBy  : "createdTime",
        orderAsc : 0,
        page     : 0,
        amount   : 50,
    },
};



/**
 * Parses the List
 * @param {Object[]} list
 * @returns {Object[]}
 */
function parseList(list) {
    return Utils.parseList(list, parseElem);
}

/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.createdDate       = DateTime.formatDate(elem.createdTime, "dashes");
    elem.createdDateTime   = DateTime.formatDate(elem.createdTime, "dashesTime");
    elem.sentDate          = DateTime.formatIf(elem.sentTime, "dashes");
    elem.sentDateTime      = DateTime.formatIf(elem.sentTime, "dashesTime");
    elem.sendToString      = Common.combineSendTo(elem);
    elem.sentSuccessString = Utils.toYesNo(elem.sentSuccess);
    return elem;
}



/**
 * The Actions
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, EMAIL_QUEUE_LIST, EMAIL_QUEUE_ELEM)) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case EMAIL_QUEUE_LOADING:
        return {
            ...state,
            loading   : true,
        };

    case EMAIL_QUEUE_LIST:
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : parseList(action.data.list),
            total     : action.data.total,
            filter    : action.data.filter,
            sort      : action.data.sort,
        };

    case EMAIL_QUEUE_ELEM:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
        };

    default:
        return state;
    }
};

export default reducer;
